import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import getUscitaMerci from "../services/getUscitaMerci";
import checkToken from "../services/checkToken";
import MyModalMagazzino from "../widgets/MyModalMagazzino";
import moment from "moment";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });

export default class UscitaMerci extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      modalEdit: {
        id: props.location.state ? props.location.state.id : '',
        show: props.location.state ? true : false,
      },
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.state && this.props.location.state.id !== prevProps.location?.state?.id) {
      let modalEdit = this.state.modalEdit;
      modalEdit.id = this.props.location.state.id;
      modalEdit.show = true;
      this.setState({ modalEdit });
      this.props.location.state = null;
    }
  }

  async reload() {
    this.setState({ isLoading: true });

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    const check = await checkToken(username, token, true);
    const userType = parseInt(check.utente.tipo);
    this.merci = await getUscitaMerci(username, token);

    this.merci.forEach((merce, i) => {
      merce.data_creazione = moment(merce.data_creazione).format('DD/MM/YYYY');
      if (merce.lista_pronta === '1' && merce.conferma_magazzino === '0') {
        this.merci[i].icon = 'Alert merce';
      }
    });

    this.setState({ isLoading: false, isUserType: (userType === 2) });
  }

  close = () => {
    let modalEdit = this.state.modalEdit;
    modalEdit.show = false;
    this.setState({ modalEdit });
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {

    if (this.state.isLoading)
      return <Loading />;

    var headCells = [
      { id: 'icon', disablePadding: false, label: '', icon: true, filter: false },
      { id: 'rif', numeric: false, disablePadding: true, label: 'Riferimento' },
      { id: 'ragione_sociale', numeric: true, disablePadding: false, label: 'Cliente' },
      { id: 'data_creazione', numeric: true, disablePadding: false, label: 'Data creazione' },
      { id: 'data_pronto', numeric: true, disablePadding: false, label: 'Data pronto' },
      { id: 'data_consegna', numeric: true, disablePadding: false, label: 'Data consegna' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    return (
      <div>
        <PageTitle title="Uscita Merci" />

        <Table headCells={headCells} searchCols={this.searchCols} rows={this.merci} order={'desc'} sortBy={1}
          onEventClick={(row) => {
            let x = {
              show: true,
              id: row
            };
            this.setState({ modalEdit: x });
          }}
        />
        {
          this.state.modalEdit.show && <MyModalMagazzino modal={this.state.modalEdit} title={"Lista di Carico"} onClose={this.close} onReload={() => this.reload()} />
        }
      </div>
    );
  }
}